import { icons } from "assets/AssetHelper";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("users_occasions.wrap"),
        name: "data?.name",
      },
      {
        label: t("users_occasions.wrap"),
        name: data?.name,
      },
      {
        label: t("users_occasions.wrap"),
        name: data?.name,
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons.detailsIcon,
    details: [
      {
        label: t("details.created_at"),
        name: data?.created_at,
      },
      {
        label: t("details.updated_at"),
        name: data?.updated_at,
      },
    ],
  },
  {
    head: t("common.prices"),
    icon: icons.detailsIcon,
    details: [
      {
        label: t("details.created_at"),
        name: data?.created_at,
        width: "30%",
      },
      {
        label: t("details.updated_at"),
        name: data?.updated_at,
        width: "30%",
      },
      {
        label: t("details.updated_at"),
        name: data?.updated_at,
        width: "30%",
      },
      {
        label: t("details.updated_at"),
        name: data?.updated_at,
        width: "30%",
      },
    ],
  },
];
